<template>
  <el-card class="h-full relative">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="主讲人姓名，课程"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-date-picker
          v-model="searchData.date"
          type="daterange"
          class="mr-10px"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
        >
        </el-date-picker>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
        <el-button
          size="small"
          type="primary"
          @click="actionHandle(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="课件名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="时长" prop="times" show-overflow-tooltip width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row.times | showText('second') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="节点数量"
          width="80px"
          prop="nodes"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="试题数量"
          width="80px"
          prop="questions"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="课程简介"
          prop="introduction"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="主讲人" prop="speaker" show-overflow-tooltip></el-table-column>
        <el-table-column label="制作人" prop="producer" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新时间" prop="fillBlankQuantity" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="课件封面" prop="questionAnswersQuantity" width="100px"
          ><template slot-scope="scope">
            <div class="p-10px w-80px text-center ">
              <question-view-image
                :imgStr="scope.row.cover"
                :setStyle="{ maxHeight: '20px', objectFit: 'cover' }"
              ></question-view-image>
            </div> </template
        ></el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="searchList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <AddDia
      :visible.sync="showAddDialog"
      v-if="showAddDialog"
      @success="searchList"
      :operateType="operateType"
      :operateData="operateData"
    />
    <el-dialog
      v-dialogDrag
      title="视频播放"
      :visible.sync="videoVisible"
      :close-on-click-modal="false"
      width="800px"
      @close="videoVisible = false"
    >
      <div class="text-center items-center justify-center w-full flex">
        <VideoCom v-if="videoVisible" :fileId="fileList" />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { CoursewareApi } from '@wiz-api/training-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import AddDia from '../../components/trainManage/AddCourseWare'
import VideoCom from '../../components/VideoPlay'
import QuestionViewImage from '../../components/QuestionViewImage'
import { formatSeconds } from '../../components/EnumField'

const coursewareApi = new CoursewareApi()

export default {
  name: 'question-bank-maintain',
  components: { AddDia, TableOperateButton, VideoCom, QuestionViewImage },
  data() {
    return {
      riskJobTypeList: [],
      // 题目类型
      questionList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        // dateStart: null,
        keywords: '',
        // dateEnd: '',
        date: [],
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      showAddDialog: false,
      videoVisible: false,
      loadFile: false,
      operateType: '',
      operateData: {},
      fileList: [],
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val.creationTime
        result = dayjs(result).format('YYYY-MM-DD HH:mm:ss')
      }
      if (type === 'second') {
        result = formatSeconds(val)
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.actionHandle(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.actionHandle(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '播放',
            click: () => {
              return this.videoPlay(val)
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.deleteHandle(val)
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
  },
  methods: {
    // 视频播放
    async videoPlay(data) {
      this.loadFile = true
      this.fileList = []
      const [err, res] = await coursewareApi.getCourseware({ id: data.id })
      this.loadFile = false
      if (err) return
      res.materials.forEach((item) => {
        this.fileList.push(item.fileId)
      })
      this.videoVisible = true
    },
    // 操作
    actionHandle(planRow, type) {
      this.operateType = type
      this.operateData = planRow
      this.showAddDialog = true
    },
    // 删除
    deleteHandle(planRow) {
      this.$confirm('此操作将删除此课件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const [err, res] = await coursewareApi.deleteMany({ ids: [planRow.id] })
            if (!err) {
              this.$message.success(this.$t('删除成功'))
              this.sizeChange()
            }
          }
        },
      })
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 设备设施列表
    async searchList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        ...searchData,
      }
      if (this.searchData.date?.length) {
        data.dateStart = dayjs(this.searchData.date[0]).format('YYYY-MM-DD HH:mm:ss')
        data.dateEnd = dayjs(this.searchData.date[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.equipTableLoading = true
      const [err, res] = await coursewareApi.getList(data)
      this.equipTableLoading = false
      if (!err) {
        this.equipDataList = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  mounted() {
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
.picture-wrap {
  display: inline-block;
  width: 200px;
}
</style>
